import ReactSelect from "react-select";
import H1 from "../../../Atoms/H1";
import ProjetEditor from "../ProjetEditor";
import { useTranslation } from "react-i18next";
import React from "react";
import Input from "../../../Atoms/Input";
import { useState } from "react";
import { SDE2024MultiSelectOptionsB } from "../../../Utils/Listings"

function valuesToOptions(value, options) {
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => value.includes(opt.value));
}

const PopB1 = (props) => {

    const defaultValues = props.defaultValues || {};

    function stringOrNonEmptyArray(value) {
        // console.log("stringOrNonEmptyArray");
        // console.log(value);

        if (value === undefined)  {
            return false
        }
        if (Array.isArray(value) && value.length === 0) {
            return false;
        }

        if (Array.isArray(value) && value.length !== 0) {
            return true;
        }
        
        if (value === '') {
            return false
        }
        else {
            return true
        }
        // if (Array.isArray(value) && value.length === 0) {
        //     return false;
        // }
        // return !!value;
    }

    const { i18n } = useTranslation('common');
    const [showMobilier, setShowMobilier] = useState(stringOrNonEmptyArray(defaultValues.mobilierType));
    const [showArtisanat, setShowArtisanat] = useState(stringOrNonEmptyArray(defaultValues.artisanatType));

    const archiIntList = SDE2024MultiSelectOptionsB.archiIntListB(i18n.language);
    const rechercheProcess = SDE2024MultiSelectOptionsB.rechercheProcessB(i18n.language);
    const rechercheProduction = SDE2024MultiSelectOptionsB.rechercheProductionB(i18n.language);
    const rechercheFlex = SDE2024MultiSelectOptionsB.rechercheFlexB(i18n.language);
    const rechercheModel = SDE2024MultiSelectOptionsB.rechercheModelB(i18n.language);
    const artisanatType = SDE2024MultiSelectOptionsB.artisanatTypeB(i18n.language);
    const artisanatScale = SDE2024MultiSelectOptionsB.artisanatScaleB(i18n.language);
    const artisanatExport = SDE2024MultiSelectOptionsB.artisanatExportB(i18n.language);
    const mobilierType = SDE2024MultiSelectOptionsB.mobilierTypeB(i18n.language);
    const mobilierExport = SDE2024MultiSelectOptionsB.mobilierExportB(i18n.language);
    const mobilierMaterial = SDE2024MultiSelectOptionsB.mobilierMaterialB(i18n.language);
    const mobilierScale = SDE2024MultiSelectOptionsB.mobilierScaleB(i18n.language);

    const handleMobilierCheckboxChange = (e) => {
        setShowMobilier(e.target.value === "oui");
    };

    const handleArtisanatCheckboxChange = (e) => {
        setShowArtisanat(e.target.value === "oui");
    };

    return (<>
        <H1>{i18n.language === "fr" ? "Vos projets" : "Your projects"}</H1>
        <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Sur quels types de projets travaillez-vous principalement ?*" : "On what types of projects do you mainly work?*"}</h2>
        <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
        <br></br>
        <div className="dropdown-container">
            <ReactSelect
                name="type_projets"
                options={archiIntList}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                style={{ marginBottom: '20px', marginTop: '20px' }}
                required
                defaultValue={valuesToOptions(defaultValues.type_projets, archiIntList)}
            />
            <br></br>
            <Input type="text" style={{ width: "100%", zIndex: "0" }} name="type_projets_precisions" placeholder="Précisez" defaultValue={defaultValues?.type_projets_precisions} />


            <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Quels sont vos spécificités / savoir-faire?*" : "What are your specialities/expertise?*"}</h2>
            <br></br>

            {/* <h3 style={{ marginBottom: '20px' }}>Artisanat d'art</h3> */}
            <h2 style={{ marginBottom: '20px' }}>{i18n.language === "fr" ? "Artisanat d'art" : "Arts and crafts"}</h2>
            <div className='checkboxlist'>
                <label>
                    <input
                        required
                        type="radio"
                        name="artisanat"
                        value="oui"
                        checked={showArtisanat}
                        onChange={handleArtisanatCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Oui" : "Yes"}<br />
                </label>
                <label>
                    <input
                        required
                        type="radio"
                        name="artisanat"
                        value="non"
                        checked={!showArtisanat}
                        onChange={handleArtisanatCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Non" : "No"}<br />
                </label>
            </div>
            {showArtisanat && (
                <>
                    {/* <ReactSelect
                name="artisanat"
                options={artisanatList}
                placeholder="Précisez ?"
                isMulti
                defaultValue={valuesToOptions(defaultValues.artisanat, artisanatList)}
            /> */}
        <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
                    <br></br>

                    <h3>{i18n.language === "fr" ? "Type de savoir-faire*" : "Type of skills*"}</h3>
                    <br></br>

                    <ReactSelect
                        name="artisanatType"
                        options={artisanatType}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.artisanatType, artisanatType)}
                    />
                    <br></br>

                    <h3>{i18n.language === "fr" ? "Échelle de production*" : "Scale of production*"}</h3>
                    <br></br>

                    <ReactSelect
                        name="artisanatScale"
                        options={artisanatScale}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.artisanatScale, artisanatScale)}
                    />
                    <br></br>

                    <h3>{i18n.language === "fr" ? "Projets à l'export*" : "Projects for export*"}</h3>
                    <br></br>


                    <ReactSelect
                        name="artisanatExport"
                        options={artisanatExport}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.artisanatExport, artisanatExport)}
                    />
                    <br></br>

                    <Input type="text" style={{ width: "100%", zIndex: "0" }} name="artisanat_precisions" placeholder="Précisez" defaultValue={defaultValues?.artisanat_precisions} />

                </>
            )}

<h2 style={{ marginBottom: '20px', marginTop: '20px' }}>{i18n.language === "fr" ? "Mobilier" : "Furniture"}</h2>
            <div className='checkboxlist'>
                <label>
                    <input
                        required
                        type="radio"
                        name="mobilier"
                        value="oui"
                        checked={showMobilier}
                        onChange={handleMobilierCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Oui" : "Yes"}<br />
                </label>
                <label>
                    <input
                        required
                        type="radio"
                        name="mobilier"
                        value="non"
                        checked={!showMobilier}
                        onChange={handleMobilierCheckboxChange}
                    />
                    {i18n.language === "fr" ? "Non" : "No"}<br />
                </label>
            </div>
            {showMobilier && (
                <>
        <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
                    <br></br>
                    <h3>{i18n.language === "fr" ? "Type de mobilier*" : "Type of furniture*"}</h3>
                    <br></br>
                    <ReactSelect
                        name="mobilierType"
                        options={mobilierType}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierType, mobilierType)}
                    />
                    <br></br>
                    <h3>{i18n.language === "fr" ? "Type de matériaux*" : "Type of materials*"}</h3>
                    <br></br>
                    <ReactSelect
                        name="mobilierMaterial"
                        options={mobilierMaterial}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierMaterial, mobilierMaterial)}
                    />
                    <br></br>
                    <h3>{i18n.language === "fr" ? "Échelle de production*" : "Scale of production*"}</h3>
                    <br></br>
                    <ReactSelect
                        name="mobilierScale"
                        options={mobilierScale}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierScale, mobilierScale)}
                    />
                    <br></br>
                    <h3>{i18n.language === "fr" ? "Projets à l'export*" : "Projects for export*"}</h3>
                    <br></br>
                    <ReactSelect
                        name="mobilierExport"
                        options={mobilierExport}
                        placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                        isMulti
                        defaultValue={valuesToOptions(defaultValues.mobilierExport, mobilierExport)}
                    />
                    <br></br>

                    <Input type="text" style={{ width: "100%", zIndex: "0" }} name="mobilier_precisions" placeholder={i18n.language === "fr" ? "Précisez" : "Please specify"} defaultValue={defaultValues?.mobilier_precisions} />

                </>
            )}
            <br></br>
            {/* <Input style={{ width: "100%", zIndex: "0" }} type="text" name="mobilier_precisions" placeholder="Champ libre" defaultValue={defaultValues?.mobilier_precisions} /> */}
            <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "En quoi votre candidature correspond aux critères recherchés pour l'évènement ?*" : "How does your application match the criteria sought for the event?*"}</h2>
            <p className="thin">{i18n.language === "fr" ? "Plusieurs réponses possibles" : "More than one answer possible"}</p>
            <br></br>


            <h3>{i18n.language === "fr" ? "Nouveaux modèles de l'économie circulaire*" : "New circular economy models*"}</h3>
            <br></br>

            <ReactSelect
                name="rechercheModel"
                options={rechercheModel}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheModel, rechercheModel)}
            />
            <br></br>
            <h3>{i18n.language === "fr" ? "Process innovants*" : "Innovative processes*"}</h3>
            <br></br>
            <ReactSelect
                name="rechercheProcess"
                options={rechercheProcess}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheProcess, rechercheProcess)}
            />
            <br></br>
            <h3>{i18n.language === "fr" ? "Production locale*" : "Local production*"}</h3>
            <br></br>
            <ReactSelect
                name="rechercheProduction"
                options={rechercheProduction}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheProduction, rechercheProduction)}
            />
            <br></br>
            <h3>{i18n.language === "fr" ? "Flexibilité d'usage*" : "Flexibility of use*"}</h3>
            <br></br>
            <ReactSelect
                name="rechercheFlex"
                options={rechercheFlex}
                placeholder={i18n.language === "fr" ? "Sélectionnez vos réponses" : "Choose your answers"}
                isMulti
                defaultValue={valuesToOptions(defaultValues.rechercheFlex, rechercheFlex)}
            />
            <br></br>
            <br></br>
            <Input type="text" style={{ width: "100%", zIndex: "0" }} name="criteres_precisions" placeholder={i18n.language === "fr" ? "Précisez" : "Please specify"} defaultValue={defaultValues?.criteres_precisions} />
        </div>
        <br />
        <h2 className="formtitle"  > {i18n.language === 'fr' ? "Partagez vos réalisations en termes de design durable dans le cadre de projets d'espace" : "Share your achievements in sustainable design in the context of space projects"}*</h2>
        <ProjetEditor eventType="sde" projets={props.projets} setDeletedProjets={props.setDeletedProjets} setProjets={props.setProjets} />
    </>);
}

export default PopB1;